import { IDonor } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { Alert } from 'react-bootstrap';
import { ActionItem } from '../../models';

interface IProps {
    list: IDonor[],
    type: ActionItem
}

const Donors = (props: IProps) => {
    if (props.type == ActionItem.DonationDateRangeConflict) {
        return (
            <>
                <Alert bsStyle='info'>Below you'll find any donors who have a donation date range within 3 weeks but are currently set to inactive.  Please activate the donor, adjust the donation date range to the new range, or delete the donor if they are no longer able to donate.</Alert>

                <TableWrapper className='table table-condensed table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'center', backgroundColor: '#ddd', borderRight: '1px solid white' }}>Donor</th>
                            <th style={{ textAlign: 'center', backgroundColor: '#ddd' }}>Donation Start Date</th>
                            <th style={{ textAlign: 'center', backgroundColor: '#ddd' }}>Donation End  Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item, index) =>
                            <tr key={index}>
                                <td><a href={`center/${item.centerId}/donor/${item.id}/profile/donor-data`} target='_blank'>{item.alias}</a></td>
                                <td>{item.donationStartDate}</td>
                                <td>{item.donationEndDate}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </>
        );
    };

    if (props.type == ActionItem.DonorEval) {
        return (
            <>
                <TableWrapper className='table table-condensed table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th>Donor</th>
                            <th>Evaluation Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item, index) =>
                            <tr key={index}>
                                <td><a href={`center/${item.centerId}/donor/${item.id}/profile/donor-data`} target='_blank'>{item.alias}</a></td>
                                <td>{item.dateOfEvaluation}</td>
                                <td>{item.pairStatus}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </>
        );
    }

    if (props.type == ActionItem.FlaggedForVoucherDonation) {
        return (
            <>
                <TableWrapper className='table table-condensed table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th>Donor</th>
                            <th>Item</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item, index) =>
                            <tr key={index}>
                                <td>
                                    <a href={`center/${item.centerId}/donor/${item.id}/profile/donor-data`} target='_blank'>{item.alias}</a>
                                </td>
                                <td style={{ textAlign: 'left' }}>
                                    This donor is ready to be activated for matching. However, their paired recipient, <a href={`center/${item.centerId}/recipient/${item.pairedRecipient.id}/profile/general`} target='_blank'>{item.pairedRecipient.alias}</a>, profile is currently not exportable.  We recommend
                                    that the donor's profile be converted to Voucher Donation.  Please contact your liaison if you need help with the conversion process.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </>
        );
    }
}

export default Donors;